import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
};
